import React from 'react';
import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchema from './stepsSchema';
import { DIET_MODES, DIET_TYPES, DIET_LEVELS } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/diet-settings/all/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={stepsSchema}
        currentMainStep="all"
        dietTypes={DIET_TYPES}
        dietLevels={DIET_LEVELS}
        dietModes={DIET_MODES}
      />
    ),
    private: true,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
